import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { clearStoredTenantId, purgeLegacyAuthStorage, setAuthToken, setStoredTenantId } from "@/lib/sm-api";
import { shouldSmPersistBearerInClient } from "@/lib/sm-session-bridge";
import { authService } from "@/lib/services";
import { notifyAppRefresh } from "@/lib/sm-app-events";
import { PageLoader } from "@/components/PageLoader";

export const Route = createFileRoute("/auth/done")({
  validateSearch: (s: Record<string, unknown>) => ({
    t: typeof s.t === "string" ? s.t : undefined,
  }),
  component: AuthDonePage,
  head: () => ({
    meta: [{ title: "Autenticando…" }, { name: "robots", content: "noindex,nofollow" }],
  }),
});

function AuthDonePage() {
  const navigate = useNavigate();
  const { t: token } = Route.useSearch();

  useEffect(() => {
    if (token && shouldSmPersistBearerInClient()) setAuthToken(token);
    else purgeLegacyAuthStorage();
    notifyAppRefresh();

    void (async () => {
      try {
        const user = await authService.getCurrentUser();
        if (!user) {
          if (!token) {
            window.location.replace("/acceso/comercio");
            return;
          }
          window.location.replace("/acceso/comercio?error=session_failed");
          return;
        }
        if (user.tenantId) setStoredTenantId(user.tenantId);
        else clearStoredTenantId();

        if (user.role === "super_admin" || user.role === "support" || user.role === "viewer") {
          void navigate({ to: "/admin", search: {} as never });
          return;
        }
        if (user.role === "owner" && !user.tenantId) {
          void navigate({ to: "/app/onboarding" });
          return;
        }
        void navigate({ to: "/app/dashboard" });
      } catch {
        window.location.replace("/acceso/comercio?error=session_failed");
      }
    })();
  }, [navigate, token]);

  return <PageLoader variant="screen" label="Iniciando sesión…" />;
}
